export const STARTER_QUESTIONS = [
  {
    id: "q1",
    min: 3,
    max: 5,
    options: ["family", "relationship", "hobbies", "personal_projects", "career", "studies", "wellbeing", "rest", "new_life_phase"],
  },
  {
    id: "q2",
    min: 3,
    max: 5,
    options: ["time_management", "prioritising", "motivation", "concentration", "stress_management", "decision_making", "calendar_planning", "work_life_balance", "building_routines", "staying_consistent", "productivity", "general_wellbeing"],
  },
  {
    id: "q3",
    min: 3,
    max: 6,
    options: ["bigger_projects", "career_development", "study_success", "building_business", "financial_stability", "better_wellbeing", "better_health", "balance", "family_life", "happiness", "more_clarity", "meaningful_life"],
  },
  {
    id: "q4",
    min: 3,
    max: 5,
    hasOther: true,
    options: ["family_responsibilities", "pets", "work", "studies", "financial_situation", "household", "health", "mental_wellbeing", "long_commuting", "contracts_obligations", "major_life_change", "other"],
  },
  {
    id: "q5",
    min: 1,
    max: 3,
    options: ["student", "working", "entrepreneur", "unemployed", "retired", "parent", "living_alone", "after_life_change", "recently_graduated", "military_civil", "other"],
  },
];

export const EMPTY_STARTERS = { q1: [], q2: [], q3: [], q4: [], q4Other: "", q5: [] };

export function startersComplete(value) {
  return STARTER_QUESTIONS.every((q) => (value[q.id] || []).length >= q.min);
}
